<div class="dialog-share-details" *ngIf="!loading">
    <app-share-member-list *ngIf="openState === shareDetailsOpenState.MEMBER_LIST" (showDialogChange)="closeDialog($event)" [selected]="selected"
    [openState]="openState" (openStateChange)="onStateChange($event)" [shareData]="shareData"></app-share-member-list>

    <app-share-options *ngIf="openState === shareDetailsOpenState.OPTIONS" (showDialogChange)="closeDialog($event)" [shareData]="shareData"
    [openState]="openState" (openStateChange)="onStateChange($event)"></app-share-options>
    
    <app-share-choose-owner *ngIf="openState === shareDetailsOpenState.CHOOSE_OWNER" (showDialogChange)="closeDialog($event)" [shareData]="shareData"
    [openState]="openState" (openStateChange)="onStateChange($event)"></app-share-choose-owner>

    <app-share-member-remove *ngIf="openState === shareDetailsOpenState.MEMBER_REMOVE" (showDialogChange)="closeDialog($event)" [shareData]="shareData"
    [openState]="openState" (openStateChange)="onStateChange($event)"></app-share-member-remove>
    
    <app-share-delete *ngIf="openState === shareDetailsOpenState.REMOVE_SHARING" (showDialogChange)="closeDialog($event)" [shareData]="shareData"
    [openState]="openState" (openStateChange)="onStateChange($event)"></app-share-delete>
    
    <app-share-permission *ngIf="openState === shareDetailsOpenState.MEMBER_PERMISSION" (showDialogChange)="closeDialog($event)" [shareData]="shareData"
    [openState]="openState" (openStateChange)="onStateChange($event)"></app-share-permission>

    <app-share-leave *ngIf="openState === shareDetailsOpenState.LEAVE_SHARE" (showDialogChange)="closeDialog($event)" [shareData]="shareData"
    [openState]="openState" (openStateChange)="onStateChange($event)"></app-share-leave>

    <app-share-member-invite *ngIf="openState === shareDetailsOpenState.MEMBER_INVITE" (showDialogChange)="closeDialog($event)" [shareData]="shareData"
    [openState]="openState" (openStateChange)="onStateChange($event)"></app-share-member-invite>

    <app-verify-email-required *ngIf="openState === shareDetailsOpenState.VERIFY_EMAIL" (showDialogChange)="closeDialog($event)"
    [openState]="openState" (openStateChange)="onStateChange($event)" [message]="verifyEmailMessage"></app-verify-email-required>

</div>
